class RequestHealthCard {
  constructor(data) {
    if (!data) return undefined;

    this.isSuccessful = data.isSuccessful;
    this.acceptedAgreementNumbers = data.acceptedAgreementNumbers;
    this.deniedAgreementNumbers = data.deniedAgreementNumbers;
  }
}

export { RequestHealthCard as default };
